import React from 'react'
import PropTypes from 'prop-types'
import VerifiedUser from '@mui/icons-material/VerifiedUser'

const VerifiedUserIcon = ({ height, width, ...more }) => {
	
	return (
		<VerifiedUser
			height={height}
			width={width}
			{...more}
		/>
	)
}

VerifiedUserIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default VerifiedUserIcon
